<div class="maintenance-page">
  <img class="bg-shape" data-aos="fade-up" data-aos-delay="100" data-aos-duration="1000"
       data-aos-easing="bounce" src="assets/images/green-background.svg">
  <img class="dots-shape" data-aos="fade-up" data-aos-delay="500" data-aos-duration="1000"
       data-aos-easing="bounce" src="assets/images/green-dots.svg">

  <div class="maintenance-header container d-flex justify-content-between align-items-center pt-3 pb-3">
    <a href="/" class="header-logo-link">
      <img src="assets/images/logos/iswint.svg" alt="ISWinT Logo" class="iswint-logo-small">
    </a>

    <div class="header-socials d-none d-md-flex align-items-center gap-3">
      <span class="announcement-text">Check 2026 announcements:</span>
      <a [href]="socialLinks.instagram" target="_blank" class="social-icon-sm">
        <img src="assets/images/logos/instagram.svg" alt="Instagram">
      </a>
      <a [href]="socialLinks.facebook" target="_blank" class="social-icon-sm">
        <img src="assets/images/logos/facebook.svg" alt="Facebook">
      </a>
      <a [href]="socialLinks.tiktok" target="_blank" class="social-icon-sm">
        <img src="assets/images/logos/tiktok.svg" alt="TikTok">
      </a>
      <a [href]="socialLinks.twitter" target="_blank" class="social-icon-sm">
        <img src="assets/images/logos/x.svg" alt="Twitter">
      </a>
    </div>
  </div>

  <div class="container hero-container">
    <div class="row align-items-center justify-content-between">
      <div class="col-12 col-lg-6" data-aos="fade-up" data-aos-delay="200" data-aos-duration="1000" data-aos-easing="bounce">
        <div class="mb-4">
          <h1 class="display-4 fw-bold">ISWinT is <span class="green">Preparing</span> Something <span class="green">Extraordinary</span></h1>
          <p class="my-4 lead">
            We are working behind the scenes to bring you an enhanced experience.
            The platform is temporarily unavailable as we prepare for the next chapter.
          </p>
        </div>

        <div class="countdown-wrapper mt-5" *ngIf="!timeRemaining.isExpired">
          <h4 class="fw-bold mb-4">We'll Be Back In:</h4>
          <div class="d-flex flex-wrap gap-3">
            <div class="time-card">
              <span class="value">{{ formatNumber(timeRemaining.days) }}</span>
              <span class="label">Days</span>
            </div>
            <div class="time-card">
              <span class="value">{{ formatNumber(timeRemaining.hours) }}</span>
              <span class="label">Hours</span>
            </div>
            <div class="time-card">
              <span class="value">{{ formatNumber(timeRemaining.minutes) }}</span>
              <span class="label">Minutes</span>
            </div>
            <div class="time-card d-none d-sm-flex">
              <span class="value">{{ formatNumber(timeRemaining.seconds) }}</span>
              <span class="label">Seconds</span>
            </div>
          </div>
        </div>

        <div class="countdown-expired mt-4" *ngIf="timeRemaining.isExpired">
          <h3 class="fw-bold m-0">We're Back!</h3>
          <p class="m-0 mt-2">The site is now available. Please refresh the page.</p>
        </div>
      </div>

      <div class="col-12 col-lg-6 mt-5 mt-lg-0" data-aos="fade-up" data-aos-delay="400" data-aos-duration="1000" data-aos-easing="bounce">
        <div class="video-wrapper shadow-effect">
          <iframe 
            src="https://www.youtube.com/embed/FeGLhL8Yj4Y?si=S7ROMhydoeqOShx8" 
            title="ISWinT Aftermovie" 
            frameborder="0" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
            allowfullscreen>
          </iframe>
        </div>
        <p class="mt-3 text-muted text-center">See what makes the ISWinT experience unique.</p>
      </div>
    </div>
  </div>


  <div class="container section-spacing" *ngIf="showGallery">
    <div class="row">
      <div class="col-12 text-center mb-5" data-aos="fade-up">
        <h2 class="fw-bold">Relive the <span class="green">Memories</span></h2>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <!-- Removed AOS to prevent transform conflicts with carousel animation -->
        <div class="carousel-wrapper">
          <div class="images-grid">
            <!-- First set -->
            <div class="grid-item"
                 *ngFor="let image of eventImages; let i = index">
              <img [src]="image.src"
                   class="grid-image">

              <div class="gallery-overlay">
                <div class="overlay-content">
                  <span class="overlay-year">{{ image.year }}</span>
                </div>
              </div>
            </div>
            <!-- Duplicate set for seamless loop -->
            <div class="grid-item"
                 *ngFor="let image of eventImages; let i = index">
              <img [src]="image.src"
                   class="grid-image">

              <div class="gallery-overlay">
                <div class="overlay-content">
                  <span class="overlay-year">{{ image.year }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Compact Footer -->
  <footer class="maintenance-footer">
    <div class="container">
      <div class="row align-items-center">
        <!-- Social Links (Desktop & Mobile) -->
        <div class="col-12 col-md-4 text-center text-md-start mb-3 mb-md-0">
          <div class="d-flex justify-content-center justify-content-md-start gap-3">
            <a [href]="socialLinks.instagram" target="_blank" class="social-icon-footer">
              <img src="assets/images/logos/instagram.svg" alt="Instagram">
            </a>
            <a [href]="socialLinks.facebook" target="_blank" class="social-icon-footer">
              <img src="assets/images/logos/facebook.svg" alt="Facebook">
            </a>
            <a [href]="socialLinks.tiktok" target="_blank" class="social-icon-footer">
              <img src="assets/images/logos/tiktok.svg" alt="TikTok">
            </a>
            <a [href]="socialLinks.twitter" target="_blank" class="social-icon-footer">
              <img src="assets/images/logos/x.svg" alt="Twitter">
            </a>
          </div>
        </div>

        <!-- Contact -->
        <div class="col-12 col-md-4 text-center mb-3 mb-md-0">
          <span class="footer-question">Have questions?</span>
          <a [href]="'mailto:' + contactEmail" class="footer-email ms-2">{{ contactEmail }}</a>
        </div>

        <!-- Copyright -->
        <div class="col-12 col-md-4 text-center text-md-end">
          <small class="text-muted">© Liga AC 1990 - {{ currentYear }}</small>
        </div>
      </div>
    </div>
  </footer>
</div>